import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer footer-four pt-4 p-0">
      {/* Footer Top */}
      <div className="footer-top aos p-0" data-aos="fade-up">
        <div className="container px-0">
          <div className="row px-0 ">
            {/* Footer Contact */}
       <div className="col-lg-3 px-0">
  <div className="footer-contact footer-widget">
    <div className="footer-logo mb-3">
      <img src="/images/logo.jpg" className="img-fluid aos" alt="logo" />
    </div>

    <div className="footer-contact-info">
      <p className="text-white">
        Travel in comfort with Shreesha Travels, offering a reliable range of cars for every journey.


      </p>

      {/* Phone */}
      <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#D40000" }}></i>
        <a href="tel:+918355835813" style={{ color: "#fff", textDecoration: "none" }}>+91 8355835813</a>
      </p>
   
     <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#D40000" }}></i>
        <a href="tel:+919930929439" style={{ color: "#fff", textDecoration: "none" }}>+91 9930929439</a>
      </p>
   
     <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#D40000" }}></i>
        <a href="tel:+919022432779" style={{ color: "#fff", textDecoration: "none" }}>+91 9022432779</a>
      </p>
   

      {/* Address */}
      <p className="d-fle align-items-start text-white">
        
        <h6><i className="fas fa-map-marker-alt me-2 mt-1 " style={{ color: "#D40000" }}></i>Shreesha Tours & Travels</h6>
      Office 125, Saishraddha CHS,
                  Plot No 47, Near Koparkhairane Police Station,
                  Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                  Maharashtra, India- 400701


      </p>
    </div>

     
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d91890.02094960261!2d72.85692930221559!3d19.114366282041622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c1b888e5e255%3A0xd9139f78b8e4feac!2sShreesha%20tours%20%26%20travels!5e1!3m2!1sen!2sin!4v1786159198880!5m2!1sen!2sin" width="100%" height="250"  allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>


    <li className="d-flex gap-3">
              <a href="https://www.instagram.com/shreesha_tours_1396_" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61592917266363" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/shreeshatravels" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://in.pinterest.com/shreeshatravels/" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
    
            </li>
  </div>
</div>

            {/* Footer Menus */}
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
            
<li><Link to="/Mumbai-Outstation-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai Outstation Cabs</Link></li>

<li><Link to="/Mumbai-to-Mahabaleshwar-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Mahabaleshwar Cab</Link></li>

<li><Link to="/Mumbai-to-Goa-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Goa Cabs</Link></li>

<li><Link to="/Mumbai-to-Shirdi-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Shirdi Cab</Link></li>

<li><Link to="/Mumbai-to-Nashik-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Nashik Cab</Link></li>

<li><Link to="/Mumbai-to-Kolhapur-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Kolhapur Cab</Link></li>

<li><Link to="/Mumbai-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Pune Cab</Link></li>

<li><Link to="/Mumbai-to-Aurangabad-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Aurangabad Cab</Link></li>

<li><Link to="/Mumbai-to-Bhimashankar-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Bhimashankar Cab</Link></li>

<li><Link to="/Mumbai-to-Ashtavinayak-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai to Ashtavinayak Cab Service</Link></li>

<li><Link to="/Mumbai-to-5-Jyotirlinga-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to 5 Jyotirlinga Cab</Link></li>

<li><Link to="/Mumbai-to-Lonavala-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Lonavala Cab</Link></li>

<li><Link to="/Mumbai-to-Konkan-Darshan-Cab-Booking"><i className="fa fa-car darkcolor"></i> Mumbai to Konkan Darshan Cab Booking</Link></li>

<li><Link to="/Mumbai-to-Alibaug-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Alibaug Cab</Link></li>

<li><Link to="/Mumbai-to-Ahmednagar-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Ahmednagar Cab</Link></li>

<li><Link to="/Mumbai-to-Matheran-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Matheran Cab</Link></li>

<li><Link to="/Mumbai-to-Jalgaon-Cab-Booking-Dhule"><i className="fa fa-car darkcolor"></i> Mumbai to Jalgaon Cab Booking / Dhule</Link></li>

<li><Link to="/Mumbai-to-Lavasa-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Lavasa Cab</Link></li>

<li><Link to="/Mumbai-to-Panchgani-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Panchgani Cab</Link></li>

<li><Link to="/Mumbai-to-Khandala-Taxi-Fare"><i className="fa fa-car darkcolor"></i> Mumbai to Khandala Taxi Fare</Link></li>

<li><Link to="/Mumbai-to-Surat-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Surat Cab</Link></li>

<li><Link to="/Mumbai-to-Ahmedabad-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Ahmedabad Cab</Link></li>

<li><Link to="/Mumbai-to-Narmada-Parikrama-Cab-Booking"><i className="fa fa-car darkcolor"></i> Mumbai to Narmada Parikrama Cab Booking</Link></li>

<li><Link to="/Mumbai-to-Baroda-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Baroda Cabs</Link></li>

<li><Link to="/Mumbai-to-Daman-Taxi"><i className="fa fa-car darkcolor"></i> Mumbai to Daman Taxi</Link></li>

<li><Link to="/Mumbai-to-Vapi-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Vapi Cab</Link></li>

<li><Link to="/Mumbai-to-Bangalore-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Bangalore Cab</Link></li>

<li><Link to="/Mumbai-to-Indore-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Indore Cab</Link></li>

<li><Link to="/Mumbai-to-Jaipur-Taxi"><i className="fa fa-car darkcolor"></i> Mumbai to Jaipur Taxi</Link></li>

<li><Link to="/Mumbai-Airport-to-Pune-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Pune Cabs</Link></li>

<li><Link to="/Mumbai-to-Imagica-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Imagica Cab</Link></li>

<li><Link to="/Cab-Service-in-Mumbai"><i className="fa fa-car darkcolor"></i> Cab Service in Mumbai</Link></li>

<li><Link to="/Best-Taxi-Service-in-Mumbai"><i className="fa fa-car darkcolor"></i> Best Taxi Service in Mumbai</Link></li>

<li><Link to="/Online-Taxi-Booking-Mumbai"><i className="fa fa-car darkcolor"></i> Online Taxi Booking Mumbai</Link></li>

<li><Link to="/Mumbai-Darshan-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai Darshan Cabs</Link></li>

<li><Link to="/Wedding-Car-Rental-Mumbai"><i className="fa fa-car darkcolor"></i> Wedding Car Rental Mumbai</Link></li>

<li><Link to="/One-Way-Cab-Service"><i className="fa fa-car darkcolor"></i> One Way Cab Service</Link></li>

<li><Link to="/Corporate-Cab-Services-in-Mumbai"><i className="fa fa-car darkcolor"></i> Corporate Cab Services in Mumbai</Link></li>

<li><Link to="/Cab-Companies-in-Mumbai"><i className="fa fa-car darkcolor"></i> Cab Companies in Mumbai</Link></li>

<li><Link to="/Mumbai-Car-Rental-Service"><i className="fa fa-car darkcolor"></i> Mumbai Car Rental Service</Link></li>
                   
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
  <ul>

<li><Link to="/Round-Trip-Cab-Booking-Mumbai"><i className="fa fa-car darkcolor"></i> Round Trip Cab Booking Mumbai</Link></li>

<li><Link to="/Cab-Service-in-Thane"><i className="fa fa-car darkcolor"></i> Cab Service in Thane</Link></li>

<li><Link to="/Cab-Service-Near-Me-Mumbai"><i className="fa fa-car darkcolor"></i> Cab Service Near Me Mumbai</Link></li>

<li><Link to="/Swift-Dzire-on-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Swift Dzire on Rent in Mumbai</Link></li>

<li><Link to="/Cab-Service-in-Navi-Mumbai"><i className="fa fa-car darkcolor"></i> Cab Service in Navi Mumbai</Link></li>

<li><Link to="/Taxi-Service-at-Mumbai-International-Airport"><i className="fa fa-car darkcolor"></i> Taxi Service at Mumbai International Airport</Link></li>

<li><Link to="/Cab-Service-in-Kalyan-Dombivali"><i className="fa fa-car darkcolor"></i> Cab Service in Kalyan / Cab Service in Dombivali</Link></li>

<li><Link to="/Innova-Car-Rental-Mumbai"><i className="fa fa-car darkcolor"></i> Innova Car Rental Mumbai</Link></li>

<li><Link to="/Innova-Crysta-on-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Innova Crysta on Rent in Mumbai</Link></li>

<li><Link to="/Ertiga-On-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Ertiga On Rent in Mumbai</Link></li>

<li><Link to="/Sedan-Cab-Service-Mumbai"><i className="fa fa-car darkcolor"></i> Sedan Cab Service Mumbai</Link></li>

<li><Link to="/Tempo-Traveller-On-Rent-Mumbai"><i className="fa fa-car darkcolor"></i> Tempo Traveller On Rent Mumbai</Link></li>

<li><Link to="/Mini-Bus-on-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Mini Bus on Rent in Mumbai</Link></li>

<li><Link to="/Kia-Carens-Cab-Service-in-Mumbai"><i className="fa fa-car darkcolor"></i> Kia Carens Cab Service in Mumbai</Link></li>

<li><Link to="/Toyota-Etios-on-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Toyota Etios on Rent in Mumbai</Link></li>

<li><Link to="/Car-Rental-Mumbai"><i className="fa fa-car darkcolor"></i> Car Rental Mumbai</Link></li>

<li><Link to="/Explore-India-Pan-India-Cab-Booking-Services"><i className="fa fa-car darkcolor"></i> Explore India / Pan India Cab Booking Services</Link></li>

<li><Link to="/Mumbai-to-Pandharpur-Akkalkot-Tuljapur-Cab-Booking"><i className="fa fa-car darkcolor"></i> Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking</Link></li>

<li><Link to="/Outstation-Taxi-Service-in-Mumbai"><i className="fa fa-car darkcolor"></i> Outstation Taxi Service in Mumbai</Link></li>

<li><Link to="/Car-Hire-for-Outstation-in-Mumbai"><i className="fa fa-car darkcolor"></i> Car Hire for Outstation in Mumbai</Link></li>

<li><Link to="/Mumbai-to-Hyderabad-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Hyderabad Cabs</Link></li>

<li><Link to="/Mumbai-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai Cab Service</Link></li>

<li><Link to="/Best-Cab-Service-in-Mumbai"><i className="fa fa-car darkcolor"></i> Best Cab Service in Mumbai</Link></li>

<li><Link to="/Mumbai-to-Ayodhya-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Ayodhya Cab</Link></li>

<li><Link to="/Mumbai-to-Saputara-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Saputara Cabs</Link></li>

<li><Link to="/Mumbai-to-Bhopal-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Bhopal Cab</Link></li>

<li><Link to="/Mumbai-to-Telangana-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai to Telangana Cab Service</Link></li>

<li><Link to="/Mumbai-to-Shani-Shingnapur-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Shani Shingnapur Cab</Link></li>

<li><Link to="/Mumbai-to-Trimbakeshwar-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Trimbakeshwar Cab</Link></li>

<li><Link to="/Mumbai-Airport-to-Vadodara-Cab"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Vadodara Cab</Link></li>

<li><Link to="/Mumbai-to-Solapur-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Solapur Cab</Link></li>

<li><Link to="/Mumbai-to-Ratnagiri-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Ratnagiri Cab</Link></li>

<li><Link to="/Mumbai-to-Grishneshwar-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Grishneshwar Cab</Link></li>

<li><Link to="/Mumbai-to-Palghar-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Palghar Cab</Link></li>

<li><Link to="/Mumbai-to-Ujjain-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Ujjain Cab</Link></li>

<li><Link to="/Mumbai-to-Jaipur-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Jaipur Cab</Link></li>

<li><Link to="/Mumbai-to-Gujarat-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Gujarat Cab</Link></li>

{/* <li><Link to="/Swift-Dzire-On-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Swift Dzire On Rent in Mumbai</Link></li> */}

{/* <li><Link to="/Ertiga-On-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Ertiga On Rent in Mumbai</Link></li> */}

<li><Link to="/Innova-On-Rent-Mumbai"><i className="fa fa-car darkcolor"></i> Innova On Rent Mumbai</Link></li>
              </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>



{/* <li><Link to="/Innova-Crysta-On-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Innova Crysta On Rent in Mumbai</Link></li> */}

<li><Link to="/Kia-Carens-On-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Kia Carens On Rent in Mumbai</Link></li>

<li><Link to="/Navi-Mumbai-Airport-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai Airport Cab</Link></li>

<li><Link to="/Navi-Mumbai-Airport-Cab-Service"><i className="fa fa-car darkcolor"></i> Navi Mumbai Airport Cab Service</Link></li>

<li><Link to="/Navi-Mumbai-Airport-to-Pune-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai Airport to Pune Cab</Link></li>

<li><Link to="/Navi-Mumbai-Airport-to-Nashik-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai Airport to Nashik Cab</Link></li>

<li><Link to="/Online-Cab-Booking-Navi-Mumbai-Airport"><i className="fa fa-car darkcolor"></i> Online Cab Booking Navi Mumbai Airport</Link></li>

<li><Link to="/Navi-Mumbai-Airport-to-Lonavala-Cabs"><i className="fa fa-car darkcolor"></i> Navi Mumbai Airport to Lonavala Cabs</Link></li>

{/* <li><Link to="/Cab-Service-in-Navi-Mumbai"><i className="fa fa-car darkcolor"></i> Cab Service in Navi Mumbai</Link></li> */}

<li><Link to="/Mumbai-Airport-Cab-Service"><i className="fa fa-car darkcolor"></i> Mumbai Airport Cab Service</Link></li>

<li><Link to="/Navi-Mumbai-to-Mahabaleshwar-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai to Mahabaleshwar Cab</Link></li>

<li><Link to="/Navi-Mumbai-to-Shirdi-Taxi-Fare"><i className="fa fa-car darkcolor"></i> Navi Mumbai to Shirdi Taxi Fare</Link></li>

<li><Link to="/Navi-Mumbai-Taxi-Service"><i className="fa fa-car darkcolor"></i> Navi Mumbai Taxi Service</Link></li>

<li><Link to="/Cheapest-Cab-Service-in-Mumbai"><i className="fa fa-car darkcolor"></i> Cheapest Cab Service in Mumbai</Link></li>

<li><Link to="/Navi-Mumbai-to-Kolhapur-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai to Kolhapur Cab</Link></li>

<li><Link to="/Innova-Crysta-On-Rent-in-Navi-Mumbai"><i className="fa fa-car darkcolor"></i> Innova Crysta On Rent in Navi Mumbai</Link></li>

<li><Link to="/Ertiga-On-Rent-in-Navi-Mumbai"><i className="fa fa-car darkcolor"></i> Ertiga On Rent in Navi Mumbai</Link></li>

<li><Link to="/Swift-Dzire-On-Rent-in-Navi-Mumbai"><i className="fa fa-car darkcolor"></i> Swift Dzire On Rent in Navi Mumbai</Link></li>

<li><Link to="/Navi-Mumbai-Airport-to-Goa-Cabs"><i className="fa fa-car darkcolor"></i> Navi Mumbai Airport to Goa Cabs</Link></li>

<li><Link to="/Navi-Mumbai-International-Airport-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai International Airport Cab</Link></li>

<li><Link to="/Navi-Mumbai-to-Ashtavinayak-Cab-Service"><i className="fa fa-car darkcolor"></i> Navi Mumbai to Ashtavinayak Cab Service</Link></li>

<li><Link to="/Navi-Mumbai-to-5-Jyotirlinga-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Navi Mumbai to 5 Jyotirlinga Darshan Cab</Link></li>

<li><Link to="/Round-Trip-Cab-Navi-Mumbai"><i className="fa fa-car darkcolor"></i> Round Trip Cab Navi Mumbai</Link></li>

<li><Link to="/Outstation-Cab-Service-Navi-Mumbai"><i className="fa fa-car darkcolor"></i> Outstation Cab Service Navi Mumbai</Link></li>

<li><Link to="/Navi-Mumbai-to-Pune-Daily-Cab-Service"><i className="fa fa-car darkcolor"></i> Navi Mumbai to Pune Daily Cab Service</Link></li>

<li><Link to="/Navi-Mumbai-Corporate-Cab-Service"><i className="fa fa-car darkcolor"></i> Navi Mumbai Corporate Cab Service</Link></li>

<li><Link to="/Navi-Mumbai-International-Airport-NMIA-Cabs"><i className="fa fa-car darkcolor"></i> Navi Mumbai International Airport (NMIA) Cabs</Link></li>

{/* <li><Link to="/Mumbai-to-Nashik-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Nashik Cab</Link></li> */}

<li><Link to="/Mumbai-to-Khatu-Shyam-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Khatu Shyam Cab</Link></li>

<li><Link to="/Mumbai-to-Nagpur-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Nagpur Cab</Link></li>

<li><Link to="/Mumbai-to-Pimpri-Chinchwad-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai to Pimpri Chinchwad Cabs</Link></li>

<li><Link to="/Navi-Mumbai-to-Goa-Cab-Service"><i className="fa fa-car darkcolor"></i> Navi Mumbai to Goa Cab Service</Link></li>

<li><Link to="/Mumbai-Airport-to-Goa-Cab"><i className="fa fa-car darkcolor"></i> Mumbai Airport to Goa Cab</Link></li>

<li><Link to="/Mumbai-to-Goa-One-Way-Cab"><i className="fa fa-car darkcolor"></i> Mumbai to Goa One Way Cab</Link></li>

<li><Link to="/Thane-to-Goa-Cabs"><i className="fa fa-car darkcolor"></i> Thane to Goa Cabs</Link></li>

<li><Link to="/Best-Mumbai-to-Goa-Cab-Service"><i className="fa fa-car darkcolor"></i> Best Mumbai to Goa Cab Service</Link></li>

<li><Link to="/Mumbai-to-Goa-Cab-Booking"><i className="fa fa-car darkcolor"></i> Mumbai to Goa Cab Booking</Link></li>

<li><Link to="/Kharghar-Taxi-Services"><i className="fa fa-car darkcolor"></i> Kharghar Taxi Services</Link></li>

<li><Link to="/Mumbai-Airport-Cabs"><i className="fa fa-car darkcolor"></i> Mumbai Airport Cabs</Link></li>

{/* <li><Link to="/Innova-Crysta-On-Rent-in-Mumbai"><i className="fa fa-car darkcolor"></i> Innova Crysta On Rent in Mumbai</Link></li> */}
 </ul>
                
                
                
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-12">
                  <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Shreesha Tours & Travels</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


